const Sk = ({ className = "", style = {} }) => (
  <div className={`sk ${className}`} style={style} />
);

export const SkeletonStatCards = ({ count = 3 }) => (
  <div className="row g-3 mb-3">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="col-4">
        <div className="card sk-stat-card-wrap">
          <div className="card-body">
            <Sk className="sk-line sk-line--short mb-3" />
            <Sk className="sk-line sk-line--number" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonCard = ({ height = 120 }) => (
  <div className="sk-card" style={{ minHeight: height }}>
    <Sk className="sk-line sk-line--short mb-3" />
    <Sk className="sk-line mb-2" />
    <Sk className="sk-line mb-2" />
    <Sk className="sk-line sk-line--medium" />
  </div>
);

export const SkeletonChart = () => (
  <div className="sk-chart-wrap">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <Sk className="sk-line sk-line--medium" />
      <Sk className="sk-line sk-line--xs" />
    </div>
    <div className="sk-chart-bars">
      {[70, 90, 40, 80, 65].map((h, i) => (
        <div key={i} className="sk-chart-bar-col">
          <div className="sk-chart-bar-pair">
            <Sk className="sk-bar" style={{ height: `${h}%` }} />
            <Sk className="sk-bar" style={{ height: `${h * 0.75}%` }} />
          </div>
          <Sk className="sk-line sk-line--xs mt-2" />
        </div>
      ))}
    </div>
    <div className="d-flex gap-4 mt-3 justify-content-center">
      <Sk className="sk-legend-item" />
      <Sk className="sk-legend-item" />
    </div>
  </div>
);

export const SkeletonAvatarList = ({ rows = 3 }) => (
  <div className="sk-avatar-list">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="sk-avatar-row">
        <Sk className="sk-avatar" />
        <div className="sk-avatar-lines">
          <Sk className="sk-line sk-line--medium mb-2" />
          <Sk className="sk-line sk-line--short" />
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonTable = ({ rows = 5, cols = 5 }) => (
  <div className="sk-table-wrap">
    <div className="sk-table-header">
      {Array.from({ length: cols }).map((_, i) => (
        <Sk key={i} className="sk-line sk-line--short" />
      ))}
    </div>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="sk-table-row">
        {Array.from({ length: cols }).map((_, j) => (
          <Sk key={j} className="sk-line" />
        ))}
      </div>
    ))}
  </div>
);

export const SkeletonPunchCard = () => (
  <div className="employee-punch-card mb-3">
    {[0, 1].map((i) => (
      <div key={i} className="sk-card sk-punch-item">
        <Sk
          className="sk-avatar sk-avatar--sm me-3"
          style={{ borderRadius: 8 }}
        />
        <div style={{ flex: 1 }}>
          <Sk className="sk-line sk-line--short mb-2" />
          <Sk className="sk-line sk-line--medium" />
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonInfoCard = ({ avatarCount = 3 }) => (
  <div className="employee-info-card">
    <Sk className="sk-line sk-line--short mb-4" />
    <div className="employee-mini-list">
      {Array.from({ length: avatarCount }).map((_, i) => (
        <div key={i} className="employee-mini-list__item">
          <Sk className="sk-avatar sk-avatar--md" />
          <Sk className="sk-line sk-line--short mt-2" />
          <Sk className="sk-line sk-line--xs mt-1" />
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonProfileCard = () => (
  <div className="profile-card">
    <div className="profile-card__top">
      <Sk className="sk-avatar sk-avatar--lg" />
      <div style={{ flex: 1 }}>
        <Sk className="sk-line sk-line--medium mb-2" />
        <Sk className="sk-line sk-line--short" />
      </div>
      <Sk className="sk-line sk-line--xs" style={{ width: 80 }} />
    </div>
    <div className="profile-card__strip mt-3">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="profile-card__strip-item">
          <Sk className="sk-line sk-line--medium mb-1" />
          <Sk className="sk-line sk-line--short" />
        </div>
      ))}
    </div>
  </div>
);

export const SkeletonQuickLinks = ({ count = 9 }) => (
  <div className="employee-quick-links-grid">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="employee-quick-links-grid__item">
        <div className="employee-quick-link-card sk-quick-card">
          <Sk
            className="sk-avatar sk-avatar--md"
            style={{ borderRadius: 12 }}
          />
          <Sk className="sk-line sk-line--short mt-2" />
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonLeaveSummary = () => (
  <div className="leave-summary-grid">
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="leave-summary-card">
        <div className="leave-summary-card__top">
          <div>
            <Sk className="sk-line sk-line--medium mb-2" />
            <Sk className="sk-line sk-line--short" />
          </div>
          <Sk className="sk-avatar sk-avatar--sm" style={{ borderRadius: 8 }} />
        </div>
        <div className="leave-summary-card__bottom mt-3">
          <Sk className="sk-line sk-line--short" />
          <Sk className="sk-line sk-line--short" />
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonLeaveCards = ({ count = 3 }) => (
  <div className="leave-cards">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="leave-card sk-card">
        <div className="d-flex justify-content-between mb-3">
          <Sk className="sk-line sk-line--medium" />
          <Sk className="sk-line sk-line--xs" />
        </div>
        <Sk className="sk-line mb-2" />
        <Sk className="sk-line sk-line--medium mb-2" />
        <Sk className="sk-line sk-line--short" />
      </div>
    ))}
  </div>
);

export const SkeletonMyTeam = ({ count = 8 }) => (
  <div className="my-team-grid">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="my-team-card">
        <Sk className="sk-avatar sk-avatar--lg" />
        <Sk className="sk-line sk-line--medium mt-2" />
        <Sk className="sk-line sk-line--short mt-1" />
      </div>
    ))}
  </div>
);

export const SkeletonFormCard = ({ fields = 4 }) => (
  <div className="sk-card" style={{ maxWidth: 560 }}>
    <Sk className="sk-line sk-line--medium mb-4" style={{ height: 22 }} />
    {Array.from({ length: fields }).map((_, i) => (
      <div key={i} className="mb-3">
        <Sk className="sk-line sk-line--short mb-2" style={{ height: 13 }} />
        <Sk className="sk-line" style={{ height: 38, borderRadius: 8 }} />
      </div>
    ))}
    <Sk
      className="sk-line sk-line--short mt-4"
      style={{ height: 38, borderRadius: 8, width: 120 }}
    />
  </div>
);

export const SkeletonNotification = ({ rows = 6 }) => (
  <div className="sk-avatar-list">
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={i}
        className="sk-avatar-row"
        style={{ padding: "12px 0", borderBottom: "1px solid #f3f3f3" }}
      >
        <Sk
          className="sk-avatar sk-avatar--md"
          style={{ borderRadius: 10, flexShrink: 0 }}
        />
        <div className="sk-avatar-lines" style={{ flex: 1 }}>
          <Sk className="sk-line mb-2" />
          <Sk className="sk-line sk-line--medium" />
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonPageHeader = () => (
  <div
    className="d-flex align-items-center justify-content-between mb-4"
    style={{ gap: 12 }}
  >
    <Sk
      className="sk-line sk-line--medium"
      style={{ height: 28, width: 200, borderRadius: 8 }}
    />
    <Sk
      className="sk-line sk-line--xs"
      style={{ height: 36, width: 140, borderRadius: 8 }}
    />
  </div>
);

export default Sk;
